/**
 * News Archive JavaScript
 * Handles filters, mobile popup, and applied filters functionality
 * @package
 * @since 1.0.0
 */

/* global FWP */
/* eslint-disable no-use-before-define, no-param-reassign, no-restricted-syntax, consistent-return */

document.addEventListener('DOMContentLoaded', function () {
  // (removed unused debounce helper)
  // Applied filter tags are now handled entirely by PHP
  // No JavaScript needed for tag rendering
  // Mobile Filters Popup Functionality
  const mobileFiltersTrigger = document.getElementById(
    'mobile-filters-trigger'
  );
  const mobileFiltersPopup = document.getElementById('mobile-filters-popup');
  const mobileFiltersClose = document.getElementById('mobile-filters-close');
  const mobileFiltersApply = document.getElementById('mobile-filters-apply');
  const mobileFiltersClearAll = document.getElementById(
    'mobile-filters-clear-all'
  );

  const mobileFiltersOverlay = document.querySelector(
    '.mobile-filters-popup__overlay'
  );

  const searchInput = document.querySelector('.search-box-input');

  const searchBarButton = document.querySelector('.search-bar-button');

  // Prevent rapid double-clicks on search action
  let searchInProgress = false;
  // Track when FacetWP's built-in Clear All (reset facet) is used
  let facetResetTriggered = false;

  let previousActiveElement = null;
  let mobilePopupOpen = false;
  let originalFWPRefresh = null;

  // Open popup
  /**
   *
   */
  function openMobileFilters() {
    previousActiveElement = document.activeElement;
    mobileFiltersPopup.setAttribute('aria-hidden', 'false');
    mobileFiltersTrigger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    mobilePopupOpen = true;

    if (typeof FWP !== 'undefined' && FWP.refresh && originalFWPRefresh) {
      FWP.refresh = function () {
        if (!mobilePopupOpen) {
          originalFWPRefresh.call(this);
        }
      };
    }

    const firstFocusable = mobileFiltersPopup.querySelector(
      'button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (firstFocusable) {
      firstFocusable.focus();
    }
  }

  // Close popup
  /**
   * Close the mobile filters popup.
   * Also resets UI when all non-ignored FacetWP facets are empty.
   * @returns {void}
   */

  /**
   *
   */
  function HandleClosePopup() {
    if (typeof window !== 'undefined' && window.FWP && window.FWP.facets) {
      const ignore = new Set([
        'sort_by',
        'result_count',
        'pagination',
        'search'
      ]);

      const allEmpty = Object.entries(window.FWP.facets).every(
        ([name, val]) =>
          ignore.has(name) || (Array.isArray(val) && val.length === 0)
      );
      if (allEmpty) {
        mobileFiltersPopup
          .querySelectorAll('.facetwp-checkbox.checked')
          .forEach(function (el) {
            el.classList.remove('checked');
          });

        // close all accordions in mobile popup
        const accordions = document.querySelectorAll('.filters-accordion');
        accordions.forEach((accordion) => {
          const trigger = accordion.querySelector(
            '.filters-accordion__trigger'
          );
          const content = accordion.querySelector(
            '.filters-accordion__content'
          );
          const icon = accordion.querySelector('.filters-accordion__icon');

          if (!trigger || !content || !icon) return;

          // On first init, set initial state based on active filters present for this accordion
          // Ensure initial closed state
          trigger.setAttribute('aria-expanded', 'false');
          content.style.display = 'none';
          icon.style.transform = 'rotate(0deg)';
        });
      }
    }
    closeMobileFilters();
  }

  /**
   *
   */
  function closeMobileFilters() {
    mobileFiltersPopup.setAttribute('aria-hidden', 'true');
    mobileFiltersTrigger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    mobilePopupOpen = false;

    if (originalFWPRefresh && window.FWP) {
      window.FWP.refresh = originalFWPRefresh;
    }

    if (previousActiveElement) {
      previousActiveElement.focus();
    }
  }

  // Apply filters and close popup
  /**
   *
   */
  function applyMobileFilters() {
    mobilePopupOpen = false;

    const mobileCheckboxes = mobileFiltersPopup.querySelectorAll(
      'input[type="checkbox"]'
    );
    mobileCheckboxes.forEach((checkbox) => {
      const facetName = checkbox
        .closest('.facetwp-facet')
        ?.getAttribute('data-name');
      if (facetName && typeof FWP !== 'undefined') {
        const { value } = checkbox;

        if (checkbox.checked) {
          if (!FWP.facets[facetName]) {
            FWP.facets[facetName] = [];
          }
          if (
            Array.isArray(FWP.facets[facetName]) &&
            !FWP.facets[facetName].includes(value)
          ) {
            FWP.facets[facetName].push(value);
          }
        } else if (Array.isArray(FWP.facets[facetName])) {
          const index = FWP.facets[facetName].indexOf(value);
          if (index > -1) {
            FWP.facets[facetName].splice(index, 1);
          }
        }
      }
    });

    if (typeof FWP !== 'undefined') {
      FWP.refresh();
    }

    closeMobileFilters();
  }

  // Clear all filters and close popup
  /**
   *
   */
  function clearAllMobileFilters() {
    mobilePopupOpen = false;

    mobileFiltersPopup
      .querySelectorAll('.facetwp-checkbox.checked')
      .forEach(function (el) {
        el.classList.remove('checked');
      });

    const searchInputs = mobileFiltersPopup.querySelectorAll(
      'input[type="text"], input[type="search"]'
    );
    searchInputs.forEach((input) => {
      input.value = '';
    });

    if (typeof FWP !== 'undefined') {
      Object.keys(FWP.facets).forEach((facetName) => {
        if (Array.isArray(FWP.facets[facetName])) {
          FWP.facets[facetName] = [];
        } else if (typeof FWP.facets[facetName] === 'string') {
          FWP.facets[facetName] = '';
        }
      });
    }

    const currentUrl = new URL(window.location);
    const paramsToRemove = [];
    for (const [key] of currentUrl.searchParams.entries()) {
      if (key.startsWith('_')) {
        paramsToRemove.push(key);
      }
    }
    paramsToRemove.forEach((param) => currentUrl.searchParams.delete(param));

    window.FWP.enable_scroll = true;

    if (currentUrl.toString() !== window.location.toString()) {
      // window.location.href = currentUrl.toString();

      if (typeof FWP !== 'undefined') {
        FWP.reset();
        // close all accordions in mobile popup
        const accordions = document.querySelectorAll('.filters-accordion');
        accordions.forEach((accordion) => {
          const trigger = accordion.querySelector(
            '.filters-accordion__trigger'
          );
          const content = accordion.querySelector(
            '.filters-accordion__content'
          );
          const icon = accordion.querySelector('.filters-accordion__icon');

          if (!trigger || !content || !icon) return;

          // On first init, set initial state based on active filters present for this accordion
          // Ensure initial closed state
          trigger.setAttribute('aria-expanded', 'false');
          content.style.display = 'none';
          icon.style.transform = 'rotate(0deg)';
        });
        closeMobileFilters();
      }
    } else {
      if (typeof FWP !== 'undefined') {
        if (originalFWPRefresh) {
          originalFWPRefresh.call(FWP);
        } else {
          FWP.refresh();
        }
      }
      closeMobileFilters();
    }
  }

  // Handle checkbox clicks in mobile popup
  /**
   *
   * @param e
   */
  function handleMobileCheckboxClick(e) {
    if (
      mobilePopupOpen &&
      e.target.type === 'checkbox' &&
      mobileFiltersPopup.contains(e.target)
    ) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();

      e.target.checked = !e.target.checked;

      if (e.target.checked) {
        e.target.classList.add('checked');
      } else {
        e.target.classList.remove('checked');
      }

      const checkboxContainer = e.target.closest('.facetwp-checkbox');
      if (checkboxContainer) {
        if (e.target.checked) {
          checkboxContainer.classList.add('checked');
        } else {
          checkboxContainer.classList.remove('checked');
        }
      }

      return false;
    }
  }

  // Prevent all FacetWP events in mobile popup
  /**
   *
   * @param e
   */
  function preventAllFacetWPEvents(e) {
    if (mobilePopupOpen && mobileFiltersPopup.contains(e.target)) {
      e.stopImmediatePropagation();
      e.stopPropagation();

      if (e.type.includes('facetwp') || e.target.closest('.facetwp-facet')) {
        e.preventDefault();
        return false;
      }
    }
  }

  // Add event listeners
  document.addEventListener('click', handleMobileCheckboxClick, true);
  document.addEventListener('change', preventAllFacetWPEvents, true);
  document.addEventListener('input', preventAllFacetWPEvents, true);
  document.addEventListener('facetwp-loaded', preventAllFacetWPEvents, true);
  document.addEventListener('facetwp-refresh', preventAllFacetWPEvents, true);

  // Override FacetWP refresh function
  if (typeof FWP !== 'undefined' && FWP.refresh) {
    originalFWPRefresh = FWP.refresh;
    FWP.refresh = function () {
      if (!mobilePopupOpen) {
        originalFWPRefresh.call(this);
      }
    };
  }

  // Event listeners
  if (mobileFiltersTrigger) {
    mobileFiltersTrigger.addEventListener('click', openMobileFilters);
  }

  if (mobileFiltersClose) {
    mobileFiltersClose.addEventListener('click', HandleClosePopup);
  }

  if (mobileFiltersOverlay) {
    mobileFiltersOverlay.addEventListener('click', HandleClosePopup);
  }

  if (mobileFiltersApply) {
    mobileFiltersApply.addEventListener('click', applyMobileFilters);
  }

  if (mobileFiltersClearAll) {
    mobileFiltersClearAll.addEventListener('click', clearAllMobileFilters);
  }

  if (searchBarButton) {
    searchBarButton.addEventListener('click', performSearch);
  }

  /**
   * Handle keydown on the visible search input. Prevents form submission
   * when Enter is pressed and triggers performSearch instead.
   * @param {KeyboardEvent} e - Keydown event
   * @returns {void}
   */
  function onSearchInputEnterKeydown(e) {
    if (e && e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      performSearch();
    }
  }

  // Prevent form submit on Enter in search input; run performSearch instead
  if (searchInput && searchInput.dataset.enterBound !== '1') {
    searchInput.addEventListener('keydown', onSearchInputEnterKeydown);
    searchInput.dataset.enterBound = '1';
  }

  // Keyboard navigation
  document.addEventListener('keydown', function (e) {
    if (mobileFiltersPopup.getAttribute('aria-hidden') === 'false') {
      if (e.key === 'Escape') {
        closeMobileFilters();
      }

      if (e.key === 'Tab') {
        const focusableElements = mobileFiltersPopup.querySelectorAll(
          'button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );
        const firstFocusable = focusableElements[0];
        const lastFocusable = focusableElements[focusableElements.length - 1];

        if (e.shiftKey) {
          if (document.activeElement === firstFocusable) {
            lastFocusable.focus();
            e.preventDefault();
          }
        } else if (document.activeElement === lastFocusable) {
          firstFocusable.focus();
          e.preventDefault();
        }
      }
    }
  });

  // Function to initialize accordion functionality
  /**
   *
   */
  function initializeAccordions() {
    const accordions = document.querySelectorAll('.filters-accordion');

    accordions.forEach((accordion) => {
      const trigger = accordion.querySelector('.filters-accordion__trigger');
      const content = accordion.querySelector('.filters-accordion__content');
      const icon = accordion.querySelector('.filters-accordion__icon');

      if (!trigger || !content || !icon) return;

      // Bind only once per trigger
      if (trigger.dataset.bound === '1') return;
      trigger.dataset.bound = '1';

      // On first init, set initial state based on active filters present for this accordion
      if (!window.__taAccordionsInitializedOnce) {
        // Ensure initial closed state
        trigger.setAttribute('aria-expanded', 'false');
        content.style.display = 'none';
        icon.style.transform = 'rotate(0deg)';

        // Collect facet names inside this accordion
        const facetEls = content.querySelectorAll('.facetwp-facet');
        const facetNamesInAccordion = new Set();
        facetEls.forEach(function (el) {
          const name = el.getAttribute('data-name');
          if (name) facetNamesInAccordion.add(name);
        });

        const hasSearchFacetInAccordion = !!content.querySelector(
          '.facetwp-facet.facetwp-type-search, .facetwp-type-search'
        );

        // Build active facet name sets
        const activeFromURL = getActiveFacetNamesFromURL();
        const activeFromFWP = getActiveFacetNamesFromFWP();
        const searchActive = isSearchActive();

        // Determine if any active facet for this accordion (excluding sort_by)
        let accordionHasActive = false;
        facetNamesInAccordion.forEach(function (name) {
          if (activeFromURL.has(name) || activeFromFWP.has(name)) {
            accordionHasActive = true;
          }
        });

        if (accordionHasActive || (searchActive && hasSearchFacetInAccordion)) {
          trigger.setAttribute('aria-expanded', 'true');
          content.style.display = 'block';
          icon.style.transform = 'rotate(180deg)';
        }
      }

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
          trigger.setAttribute('aria-expanded', 'false');
          content.style.display = 'none';
          icon.style.transform = 'rotate(0deg)';
        } else {
          trigger.setAttribute('aria-expanded', 'true');
          content.style.display = 'block';
          icon.style.transform = 'rotate(180deg)';
        }
      });
    });

    // Mark that we performed the initial state setup once
    if (!window.__taAccordionsInitializedOnce) {
      window.__taAccordionsInitializedOnce = true;
    }
  }

  // Batched post-FacetWP tasks scheduler
  /**
   * Runs all post-render tasks after FacetWP updates in a single batch
   */
  function runPostFacetTasks() {
    // Only initialize accordions' initial open/close state once (on page load)
    if (!window.__taAccordionsInitializedOnce) {
      initializeAccordions();
    }
    ensureFacetVisibility();
    kickFacetIfEmpty();
    bindSearchThreshold();
    toggleAppliedFilters();
    bindFacetResetHandler();

    if (
      window.location.pathname === '/search' ||
      window.location.pathname === '/search/'
    ) {
      if (typeof FWP !== 'undefined') {
        if (FWP.facets.search) {
          if (FWP.facets.search.length === 0) {
            searchInput.value = '';
          }
        }

        // Bind handlers to clear FacetWP search facet when input is cleared or clear icon clicked
        bindSearchClearHandlers();
      }
    }
  }

  let postTasksRafId = null;
  /**
   * Schedule post-render tasks for next animation frame (debounced)
   */
  function schedulePostFacetTasks() {
    if (postTasksRafId) {
      cancelAnimationFrame(postTasksRafId);
    }
    postTasksRafId = requestAnimationFrame(function () {
      postTasksRafId = null;
      runPostFacetTasks();
    });
  }

  /**
   * Wait until FacetWP is present, then run the post tasks once
   */
  function waitForFacetWPAndInit() {
    if (typeof FWP !== 'undefined') {
      schedulePostFacetTasks();
    } else {
      setTimeout(waitForFacetWPAndInit, 100);
    }
  }

  /**
   * Bind events to keep FacetWP search facet empty when user clears the input
   */
  function bindSearchClearHandlers() {
    const searchClear = document.querySelector('.search-box-clear');

    // Show/hide the clear icon based on current input value
    /**
     * Toggle visibility of the search clear icon based on input value
     * @returns {void}
     */
    function updateClearVisibility() {
      if (!searchClear) return;
      const currentValue =
        searchInput && searchInput.value ? searchInput.value.trim() : '';
      searchClear.style.display = currentValue === '' ? 'none' : '';
    }

    // Shared routine to clear facet, DOM input, URL param, and refresh
    /**
     *
     */
    function clearFacetAndUrl() {
      if (typeof window.FWP !== 'undefined') {
        try {
          window.FWP.facets = window.FWP.facets || {};
          // Clear search facet in both array and string forms
          window.FWP.facets.search = [];
          if (typeof window.FWP.facets.search === 'string') {
            window.FWP.facets.search = '';
          }
          const facetTextInput = document.querySelector(
            '.facetwp-type-search input'
          );
          if (facetTextInput) {
            facetTextInput.value = '';
          }

          // Remove _search from URL without reloading
          try {
            const url = new URL(window.location);
            if (url.searchParams.has('_search')) {
              url.searchParams.delete('_search');
              window.history.replaceState({}, '', url.toString());
            }
          } catch (err) {
            // noop
          }

          window.FWP.refresh();
        } catch (err) {
          // noop
        }
      }
    }

    if (searchInput && searchInput.dataset.clearBound !== '1') {
      searchInput.addEventListener('input', function onSearchInput(e) {
        // If user manually clears the field, clear the FacetWP search facet and refresh
        const val = e.target.value || '';
        if (val.trim() === '') {
          // Defer to ensure value reflects the latest key event
          setTimeout(clearFacetAndUrl, 0);
        }
        updateClearVisibility();
      });

      // Also handle keyup for Backspace/Delete edge cases in some browsers
      searchInput.addEventListener('keyup', function onSearchKeyup(e) {
        const isBackspaceOrDelete = e.key === 'Backspace' || e.key === 'Delete';
        if (isBackspaceOrDelete && (e.target.value || '').trim() === '') {
          setTimeout(clearFacetAndUrl, 0);
        }
        updateClearVisibility();
      });
      searchInput.dataset.clearBound = '1';
    }

    if (searchClear && searchClear.dataset.clearBound !== '1') {
      searchClear.addEventListener('click', function onSearchClearClick(e) {
        e.preventDefault();
        if (searchInput) {
          searchInput.value = '';
        }
        // Also clear the internal facet input if present
        const facetTextInput = document.querySelector(
          '.facetwp-type-search input'
        );
        if (facetTextInput) {
          facetTextInput.value = '';
        }
        // Use the same clearing routine
        setTimeout(clearFacetAndUrl, 0);
        updateClearVisibility();
      });
      searchClear.dataset.clearBound = '1';
    }

    // Initialize correct visibility on load
    updateClearVisibility();
  }

  // Determine if search facet is active via FWP or URL params
  /**
   *
   */
  function isSearchActive() {
    if (typeof FWP !== 'undefined' && FWP.facets) {
      let v = FWP.facets.search;
      if (Array.isArray(v)) v = v[0] || '';
      if (typeof v === 'string' && v.trim() !== '') return true;
    }
    try {
      const url = new URL(window.location);
      const s = url.searchParams.get('_search') || '';
      if (s.trim() !== '') return true;
    } catch (e) {
      /* noop */
    }
    return false;
  }

  /**
   * Perform search by syncing the visible search input with FacetWP's search facet,
   * updating the _search URL param, enabling smooth scroll, and triggering refresh.
   * @returns {void}
   */
  function performSearch() {
    try {
      if (searchInProgress) {
        return;
      }

      searchInProgress = true;
      if (searchBarButton) {
        searchBarButton.disabled = true;
        searchBarButton.setAttribute('aria-busy', 'true');
      }

      const term = (
        searchInput && searchInput.value ? searchInput.value : ''
      ).trim();

      if (typeof window !== 'undefined' && typeof window.FWP !== 'undefined') {
        // Ensure facets object exists
        window.FWP.facets = window.FWP.facets || {};

        // Sync the underlying FacetWP search input (if present)
        const facetTextInput = document.querySelector(
          '.facetwp-type-search input'
        );
        if (facetTextInput) {
          facetTextInput.value = term;
        }

        // Apply value to FacetWP search facet
        if (term === '') {
          window.FWP.facets.search = [];
        } else {
          window.FWP.facets.search = [term];
        }

        // Update URL param without reloading
        try {
          const url = new URL(window.location);
          if (term === '') {
            url.searchParams.delete('_search');
          } else {
            url.searchParams.set('_search', term);
          }
          window.history.replaceState({}, '', url.toString());
        } catch (e) {
          // noop
        }

        // Enable smooth scroll to results on refresh
        window.FWP.enable_scroll = true;

        // Trigger FacetWP refresh
        if (typeof window.FWP.refresh === 'function') {
          window.FWP.refresh();
        } else if (typeof window.FWP.autoload === 'function') {
          window.FWP.autoload();
        }

        // Re-enable button after results load
        const onFacetLoadedOnce = function onFacetLoadedOnce() {
          searchInProgress = false;
          if (searchBarButton) {
            searchBarButton.disabled = false;
            searchBarButton.removeAttribute('aria-busy');
          }
          document.removeEventListener('facetwp-loaded', onFacetLoadedOnce);
        };
        document.addEventListener('facetwp-loaded', onFacetLoadedOnce);
      }
    } catch (err) {
      // noop
    } finally {
      // Safety fallback in case FacetWP events do not fire for any reason
      setTimeout(function () {
        if (searchInProgress) {
          searchInProgress = false;
          if (searchBarButton) {
            searchBarButton.disabled = false;
            searchBarButton.removeAttribute('aria-busy');
          }
        }
      }, 2000);
    }
  }

  /**
   * Bind FacetWP reset facet (Clear All) to mark that a reset was triggered.
   * @returns {void}
   */
  function bindFacetResetHandler() {
    try {
      const resetLinks = document.querySelectorAll('.facetwp-reset');
      resetLinks.forEach(function (link) {
        if (link.dataset.resetBound === '1') return;
        link.addEventListener('click', function () {
          facetResetTriggered = true;
        });
        link.dataset.resetBound = '1';
      });
    } catch (e) {
      // noop
    }
  }

  /**
   * Add/remove 'Relevance' option in the sort_by facet based on search activity.
   * If removed while selected, fallback to the first available option and refresh.
   * @returns {void}
   */
  function updateSortByRelevanceOption() {
    try {
      const sortFacet = document.querySelector(
        '.facetwp-facet[data-name="sort_by"]'
      );
      if (!sortFacet) return;

      const selectEl = sortFacet.querySelector('select');
      if (!selectEl) return;

      const searchActive = isSearchActive();
      const relevanceValue = 'relevance';
      const relevanceLabel = 'Relevance';
      let relevanceOption = selectEl.querySelector(
        `option[value="${relevanceValue}"]`
      );

      if (searchActive) {
        if (!relevanceOption) {
          relevanceOption = document.createElement('option');
          relevanceOption.value = relevanceValue;
          relevanceOption.textContent = relevanceLabel;
          // append to the end as requested
          selectEl.appendChild(relevanceOption);
        } else if (selectEl.lastElementChild !== relevanceOption) {
          // ensure it's the last option if already present
          selectEl.appendChild(relevanceOption);
        }

        // If current FacetWP state is relevance, reflect it in the UI
        if (
          typeof window !== 'undefined' &&
          window.FWP &&
          (window.FWP.facets?.sort_by === relevanceValue ||
            (Array.isArray(window.FWP.facets?.sort_by) &&
              (window.FWP.facets.sort_by[0] || '') === relevanceValue))
        ) {
          selectEl.value = relevanceValue;
        }
      } else if (relevanceOption) {
        const wasSelected = relevanceOption.selected === true;
        relevanceOption.remove();
        if (wasSelected) {
          // Clear sort_by instead of forcing a fallback value so URL has no _sort_by
          if (typeof window !== 'undefined' && window.FWP) {
            window.FWP.facets = window.FWP.facets || {};
            window.FWP.facets.sort_by = '';
            if (typeof window.FWP.refresh === 'function') {
              window.FWP.refresh();
            }
          }
          // Update select UI to first option without implying a value
          if (selectEl.options && selectEl.options.length) {
            selectEl.selectedIndex = 0;
          }
          // Also strip _sort_by from URL immediately
          try {
            const url = new URL(window.location);
            if (url.searchParams.has('_sort_by')) {
              url.searchParams.delete('_sort_by');
              window.history.replaceState({}, '', url.toString());
            }
          } catch (e) {
            // noop
          }
        }
      }
    } catch (e) {
      // noop
    }
  }

  // Ensure facet containers are not hidden by inline styles after search
  /**
   *
   */
  function ensureFacetVisibility() {
    const facets = document.querySelectorAll(
      '.filters-accordion__content .facetwp-facet'
    );
    facets.forEach((facet) => {
      if (facet.style && facet.style.display === 'none') {
        facet.style.display = '';
      }
      facet.classList.remove('facetwp-hidden');

      // If facet has no checkbox items, show a helpful placeholder
      const hasItems = facet.querySelector('.facetwp-checkbox');
      let emptyMsg = facet.querySelector('.facetwp-empty-msg');
      if (!hasItems) {
        if (!emptyMsg) {
          emptyMsg = document.createElement('div');
          emptyMsg.className = 'facetwp-empty-msg';
          emptyMsg.style.color = 'var(--constant-white, #fff)';
          emptyMsg.style.fontSize = '14px';
          emptyMsg.style.opacity = '0.8';
          emptyMsg.textContent = 'No filter options for current results';
          facet.appendChild(emptyMsg);
        }
      } else if (emptyMsg) {
        emptyMsg.remove();
      }
    });
  }

  // If facets failed to populate, trigger a FacetWP refresh once
  let triedKickOnce = false;
  /**
   *
   */
  function kickFacetIfEmpty() {
    if (typeof FWP === 'undefined') return;
    const hasAnyCheckbox = document.querySelector(
      '.facetwp-facet .facetwp-checkbox'
    );
    if (!hasAnyCheckbox && !triedKickOnce) {
      triedKickOnce = true;
      try {
        FWP.refresh();
      } catch (e) {
        // no-op
      }
    }
  }

  /**
   * Return a Set of active facet names derived from URL params (leading '_' stripped)
   * Excludes non-filter params like _sort_by
   */
  function getActiveFacetNamesFromURL() {
    const active = new Set();
    try {
      const url = new URL(window.location);
      for (const [key, value] of url.searchParams.entries()) {
        const isFacetParam = key && key.startsWith('_');
        const isSortParam = key === '_sort_by';
        const isPagedParam = key === '_paged';
        const hasValue = typeof value === 'string' && value.trim() !== '';
        if (isFacetParam && !isSortParam && !isPagedParam && hasValue) {
          const facetName = key.slice(1);
          if (facetName) {
            active.add(facetName);
          }
        }
      }
    } catch (e) {
      // noop
    }
    return active;
  }

  /**
   * Return a Set of active facet names derived from FWP.facets
   */
  function getActiveFacetNamesFromFWP() {
    const active = new Set();
    if (typeof FWP === 'undefined' || !FWP.facets) return active;
    for (const facetName in FWP.facets) {
      if (Object.prototype.hasOwnProperty.call(FWP.facets, facetName)) {
        const isSortFacet = facetName === 'sort_by';
        if (!isSortFacet) {
          const facetValue = FWP.facets[facetName];
          if (Array.isArray(facetValue) && facetValue.length > 0) {
            active.add(facetName);
          } else if (
            typeof facetValue === 'string' &&
            facetValue.trim() !== ''
          ) {
            active.add(facetName);
          } else if (typeof facetValue === 'number' && facetValue !== 0) {
            active.add(facetName);
          }
        }
      }
    }
    return active;
  }

  // Removed hasAppliedFilters(): visibility now based solely on actual selection chips

  // Function to show/hide applied filters section
  /**
   * Shows or hides the applied filters section based on filter state
   */
  function toggleAppliedFilters() {
    const appliedFiltersSection = document.getElementById('applied-filters');

    if (!appliedFiltersSection) {
      return;
    }

    // Also check if there are actual filter tags displayed
    const appliedFilterTags = document.getElementById('applied-filter-tags');
    const selectionsFacet = appliedFilterTags
      ? appliedFilterTags.querySelector('.facetwp-selections')
      : document.querySelector('.facetwp-selections');

    // Determine if there are actual selection chips, not just the reset link
    let hasActualSelectionChips = false;
    if (selectionsFacet) {
      // Count any selection items inside, excluding reset link/button
      const chips = selectionsFacet.querySelectorAll(
        '.facetwp-selection, [data-facet]'
      );
      const resets = selectionsFacet.querySelectorAll(
        '.facetwp-reset, [data-facet-reset]'
      );
      const chipCount = chips ? chips.length : 0;
      const resetCount = resets ? resets.length : 0;
      hasActualSelectionChips = chipCount > 0 && chipCount > resetCount;
    }

    if (hasActualSelectionChips) {
      appliedFiltersSection.style.display = 'block';
    } else {
      appliedFiltersSection.style.display = 'none';
    }

    // Mobile clear all button

    if (typeof window !== 'undefined' && window.FWP && window.FWP.facets) {
      const ignore = new Set([
        'sort_by',
        'result_count',
        'pagination',
        'search'
      ]);

      const allEmpty = Object.entries(window.FWP.facets).every(
        ([name, val]) =>
          ignore.has(name) || (Array.isArray(val) && val.length === 0)
      );
      if (allEmpty) {
        mobileFiltersClearAll.classList.add('facetwp-hidden');
      } else {
        mobileFiltersClearAll.classList.remove('facetwp-hidden');
      }
    } else {
      mobileFiltersClearAll.classList.add('facetwp-hidden');
    }
  }

  // Initialize post tasks
  waitForFacetWPAndInit();

  // Re-initialize accordions on FacetWP events
  document.addEventListener('facetwp-loaded', schedulePostFacetTasks);
  document.addEventListener('facetwp-refresh', schedulePostFacetTasks);

  // FacetWP scroll-to-top behavior for archive grid
  /**
   * Handle FacetWP refresh to set enable_scroll
   */
  const onFacetRefresh = () => {
    if (typeof window !== 'undefined' && typeof window.FWP !== 'undefined') {
      window.FWP.enable_scroll = !!window.FWP.soft_refresh;
    }
  };

  /**
   * Smoothly scroll so the posts grid top aligns with viewport top,
   * accounting for fixed header/spacer/admin bar offset.
   */
  const scrollGridToTop = () => {
    try {
      const grid =
        document.querySelector('.posts-grid') ||
        document.querySelector('.posts-grid');
      if (!grid) return;

      // Compute absolute top position
      const rect = grid.getBoundingClientRect();
      const pageYOffset =
        window.pageYOffset || document.documentElement.scrollTop || 0;
      let targetTop = rect.top + pageYOffset;

      // Offsets: header spacer, fixed header, and WP admin bar if present
      const spacer = document.querySelector('.site-header-spacer');
      const header = document.querySelector('.site-header');
      const adminBar = document.getElementById('wpadminbar');
      const spacerH = spacer ? spacer.offsetHeight : 0;
      const headerH = header ? header.offsetHeight : 0;
      const adminH = adminBar ? adminBar.offsetHeight : 0;
      const offset = Math.max(spacerH, headerH, 0) + adminH + 8; // small margin

      targetTop = Math.max(targetTop - offset, 0);

      if (typeof window.scrollTo === 'function') {
        window.scrollTo({ top: targetTop, behavior: 'smooth' });
      } else if (typeof window.scroll === 'function') {
        window.scroll(0, targetTop);
      }
    } catch (err) {
      // no-op
    }
  };

  /**
   * Handle FacetWP loaded event to trigger scroll when flagged
   */
  const onFacetLoaded = () => {
    if (typeof window !== 'undefined' && typeof window.FWP !== 'undefined') {
      // After a reset facet is used, ensure URL is cleaned and inputs cleared
      if (facetResetTriggered) {
        facetResetTriggered = false;
        try {
          // Remove all FacetWP params from URL
          const url = new URL(window.location);
          const toDelete = [];
          for (const [key] of url.searchParams.entries()) {
            if (key && key.startsWith('_')) toDelete.push(key);
          }
          toDelete.forEach((k) => url.searchParams.delete(k));
          window.history.replaceState({}, '', url.toString());
        } catch (e) {
          // noop
        }
        // Clear visible search input if present
        if (searchInput) {
          searchInput.value = '';
        }
      }

      // Update sort_by options visibility once per load
      updateSortByRelevanceOption();

      // Toggle Sort UI visibility based on results count
      try {
        const sortWrap = document.querySelector('.results-header__right');
        if (sortWrap) {
          const totalRows =
            window.FWP &&
            window.FWP.settings &&
            window.FWP.settings.pager &&
            typeof window.FWP.settings.pager.total_rows === 'number'
              ? window.FWP.settings.pager.total_rows
              : null;

          if (totalRows === 0) {
            sortWrap.style.display = 'none';
          } else if (totalRows > 0) {
            sortWrap.style.display = '';
          }
        }
      } catch (e) {
        // no-op
      }

      if (window.FWP.enable_scroll === true) {
        scrollGridToTop();
      }
    }
  };

  document.addEventListener('facetwp-refresh', onFacetRefresh);
  document.addEventListener('facetwp-loaded', onFacetLoaded);

  // selections facet will output tags; JS syncing removed

  // Auto-refresh using FacetWP's documented approach (2+ chars)
  /**
   *
   */
  // eslint-disable-next-line no-unused-vars
  function bindSearchThreshold() {
    const facets = document.querySelectorAll('.facetwp-type-search');
    facets.forEach((facet) => {
      if (facet.dataset.thresholdBound === '1') return;
      facet.addEventListener('keyup', function (e) {
        if (typeof FWP !== 'object' || FWP.is_refresh) return;
        const trigger = 2;
        e.stopPropagation();
        const facetEl = this.closest('.facetwp-facet') || this;
        const facetName = facetEl.getAttribute('data-name');
        const inputEl = this.querySelector('input');
        const sel = inputEl ? inputEl.value : '';

        if (FWP.settings && typeof FWP.settings[facetName] !== 'undefined') {
          const auto = FWP.settings[facetName].auto_refresh;
          if (auto === 'yes' && !(trigger > sel.length && sel.length > 0)) {
            if (
              FWP.logic &&
              FWP.logic.search &&
              FWP.logic.search.delay_refresh
            ) {
              FWP.logic.search.delay_refresh(facetName);
            } else if (typeof FWP.autoload === 'function') {
              FWP.autoload();
            }
          } else if (e.keyCode === 13 && typeof FWP.autoload === 'function') {
            FWP.autoload();
          }
        }
      });
      facet.dataset.thresholdBound = '1';
    });
  }
});
